import React, { useEffect } from "react";

const SuccessDialog = ({ isVisible, onClose, message }) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000); // Aumentei para 5 segundos para dar tempo de ler
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="w-[90%] max-w-[500px] p-[22px] bg-white rounded-md shadow-md border border-gray-200 flex flex-col items-center gap-3">
                <div className="flex items-center gap-3 w-full">
                    <div className="w-15 h-15 pt-[6.50px] pb-[5.50px] justify-center items-center flex overflow-hidden">
                        <img
                            className="w-12 h-12"
                            src="/images/icon/save.gif"
                            alt="Ícone de Sucesso"
                        />
                    </div>
                    <div className="flex-1">
                        <div className="text-stone-800 text-lg font-semibold mb-2">
                            Sucesso!
                        </div>
                        {message && (
                            <div className="text-stone-600 text-sm whitespace-pre-line">
                                {message}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuccessDialog;
